import { LucideIcon } from "lucide-react";
import { CYCLE_BANNER_CLASS_NAME, PRIMARY_HEX } from "../constants";

export interface CycleBannerItem {
  label: string;
  value: string;
  valueClassName?: string;
  highlight?: string;
  highlightClassName?: string;
  note?: string;
  noteTitle?: string;
  Icon: LucideIcon;
}

interface CycleBannerProps {
  items: readonly CycleBannerItem[];
}

const HIGHLIGHT_SEPARATOR: string = " · ";

export function CycleBanner({ items }: CycleBannerProps): JSX.Element {
  return (
    <div className={CYCLE_BANNER_CLASS_NAME}>
      <div className="grid w-full grid-cols-1 gap-4 px-5 py-4 sm:grid-cols-2 xl:grid-cols-4">
        {items.map((item: CycleBannerItem) => (
          <div key={item.label} className="flex items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-white/70">
              <item.Icon className="h-5 w-5" color={PRIMARY_HEX} />
            </div>

            <div className="min-w-0">
              <p className="text-[11px] font-semibold uppercase tracking-wider text-[#613F4F]/70">
                {item.label}
              </p>

              <p className="text-sm font-bold text-gray-900">
                <span className={item.valueClassName}>{item.value}</span>

                {item.highlight && (
                  <>
                    {HIGHLIGHT_SEPARATOR}
                    <span className={item.highlightClassName}>
                      {item.highlight}
                    </span>
                  </>
                )}

                {item.note && (
                  <span
                    className="ml-1 text-xs font-medium text-gray-500"
                    title={item.noteTitle}
                  >
                    {item.note}
                  </span>
                )}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
